import React, { useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  CardBody,
  FormGroup,
  Button,
  Spinner,
  ListGroup,
} from "react-bootstrap";
import {
  IconUser,
  IconBuildings,
  IconBuildingBank,
  IconPhone,
  IconWorldWww,
  IconWorldPin,
  IconMailForward,
} from "@tabler/icons-react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useFormContext, Controller } from "react-hook-form";
import { useEffect } from "react";

function BillingInfo() {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const [showForm, setShowForm] = useState(false);
  const handleCheckboxChange = (e) => {
    setShowForm(!e.target.checked);
  };

  const email = watch("primary_email");
  const contact = watch("primary_phone");
  const firstName = watch("first_name");
  const lastName = watch("last_name");

  useEffect(() => {
  const currentName = watch("billing_name");
  const currentPhone = watch("billing_phone");
  const currentEmail = watch("billing_email");

  if (!currentName && (firstName || lastName)) {
    setValue("billing_name", `${firstName ?? ""} ${lastName ?? ""}`.trim());
  }

  if (!currentPhone && contact) {
    setValue("billing_phone", contact);
  }

  if (!currentEmail && email) {
    setValue("billing_email", email);
  }
}, []);

  
  // useEffect(() => {
  //   const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  //   if (fullName) setValue("billing_name", fullName);
  //   if (contact) setValue("billing_phone", contact);
  //   if (email) setValue("billing_email", email);
  // }, []);

  return (
    <>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Full Name</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter Full Name"
                {...register("billing_name")}
              />
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              {errors.billing_name && (
                <span className="text-danger">
                  {errors.billing_name.message}
                </span>
              )}
            </InputGroup>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter  Email"
                {...register("billing_email")}
              />
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.billing_email && (
              <span className="text-danger">
                {errors.billing_email.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>

            <InputGroup>
              <InputGroup.Text>
                <IconPhone stroke={1} />
              </InputGroup.Text>
              <Controller
                name="billing_phone"
                control={control}
                rules={{
                  required: "Phone number is required",
                  validate: (value) =>
                    (value && value.length > 0) || "Invalid phone number",
                }}
                render={({ field }) => (
                  <PhoneInput
                    className="form-control"
                    {...field}
                    defaultCountry="US"
                    countryCallingCodeEditable={false}
                    international
                    placeholder="Enter phone number"
                    onChange={field.onChange}
                  />
                )}
              />
            </InputGroup>
            {errors.billing_phone && (
              <span className="text-danger">
                {errors.billing_phone.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Street Address 1</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter Address 1"
                {...register("Bill_address_1")}
              />
              <InputGroup.Text>
                <IconBuildings stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.Bill_address_1 && (
              <span className="text-danger">
                {errors.Bill_address_1.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Street Address 2</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Street Address 2"
                {...register("Bill_address_2")}
              />
              <InputGroup.Text>
                <IconBuildings stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.Bill_address_2 && (
              <span className="text-danger">
                {errors.Bill_address_2.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>City</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter City"
                {...register("Bill_city")}
              />
              <InputGroup.Text>
                <IconBuildingBank stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.Bill_city && (
              <span className="text-danger">{errors.Bill_city.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>State</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter Your State"
                {...register("Bill_state")}
              />
              <InputGroup.Text>
                <IconBuildingBank stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.Bill_state && (
              <span className="text-danger">{errors.Bill_state.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>ZIP Code</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter your area’s ZIP Code"
                {...register("Bill_zip_code")}
              />
              <InputGroup.Text>
                <IconMailForward stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.Bill_zip_code && (
              <span className="text-danger">
                {errors.Bill_zip_code.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Country</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter Your Country"
                {...register("Bill_country")}
              />
              <InputGroup.Text>
                <IconWorldPin stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.Bill_country && (
              <span className="text-danger">{errors.Bill_country.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Check
            {...register("sameAddress")}
            type="checkbox"
            id="sameAddress"
            label="Shipping Same as Billing Address"
            checked={!showForm}
            onChange={handleCheckboxChange}
          />
        </Col>
      </Row>

      {showForm && (
        <div className="mt-3">
          <h5 className="mb-3">Shipping Address</h5>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Enter Full Name"
                    {...register("shipping_name")}
                  />
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  {errors.shipping_name && (
                    <span className="text-danger">
                      {errors.shipping_name.message}
                    </span>
                  )}
                </InputGroup>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Enter  Email"
                    {...register("shipping_email")}
                  />
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                </InputGroup>

                {errors.shipping_email && (
                  <span className="text-danger">
                    {errors.shipping_email.message}
                  </span>
                )}
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>

                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="shipping_phone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.shipping_phone && (
                  <span className="text-danger">
                    {errors.shipping_phone.message}
                  </span>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Street Address 1</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Enter Address 1"
                    {...register("Ship_address_1")}
                  />
                  <InputGroup.Text>
                    <IconBuildings stroke={1} />
                  </InputGroup.Text>
                </InputGroup>
                {errors.Ship_address_1 && (
                  <span className="text-danger">
                    {errors.Ship_address_1.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Street Address 2</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Street Address 2"
                    {...register("Ship_address_2")}
                  />
                  <InputGroup.Text>
                    <IconBuildings stroke={1} />
                  </InputGroup.Text>
                </InputGroup>
                {errors.Ship_address_2 && (
                  <span className="text-danger">
                    {errors.Ship_address_2.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Enter City Name"
                    {...register("Ship_city")}
                  />
                  <InputGroup.Text>
                    <IconBuildingBank stroke={1} />
                  </InputGroup.Text>
                </InputGroup>
                {errors.Ship_city && (
                  <span className="text-danger">
                    {errors.Ship_city.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>State</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Enter Your State"
                    {...register("Ship_state")}
                  />
                  <InputGroup.Text>
                    <IconBuildingBank stroke={1} />
                  </InputGroup.Text>
                </InputGroup>
                {errors.Ship_state && (
                  <span className="text-danger">
                    {errors.Ship_state.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>ZIP Code</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Enter your area’s ZIP Code"
                    {...register("Ship_zip_code")}
                  />
                  <InputGroup.Text>
                    <IconMailForward stroke={1} />
                  </InputGroup.Text>
                </InputGroup>
                {errors.Ship_zip_code && (
                  <span className="text-danger">
                    {errors.Ship_zip_code.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Country</Form.Label>
                <InputGroup>
                  <Form.Control
                    placeholder="Enter Your Country"
                    {...register("Ship_country")}
                  />
                  <InputGroup.Text>
                    <IconWorldPin stroke={1} />
                  </InputGroup.Text>
                </InputGroup>
                {errors.Ship_country && (
                  <span className="text-danger">
                    {errors.Ship_country.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default BillingInfo;
